<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <div class="page">
          <div class="weui-msg"
               v-if="isPaySuccess">
            <div class="weui-msg__icon-area">
              <i class="weui-icon_msg"
                 :class="[isPaySuccess ? 'weui-icon-success':'weui-icon-warn']"></i>
            </div>
            <div class="weui-msg__text-area">
              <h2 class="weui-msg__title">{{ price | currency2 }}</h2>
              <p class="weui-msg__desc">{{ payStatus.status == 'success' ? '支付成功' : '支付失败' }}</p>
            </div>
            <div class="weui-msg__opr-area">
              <c-footer v-if="isPaySuccess">
                <c-button btn-type="default"
                          @click.native="goToMarket">商城首页</c-button>
                <c-button @click.native="goToOrderList">查看订单</c-button>
              </c-footer>
              <!--<c-footer v-else>-->
              <!--<c-button @click.native="rePay">重新支付</c-button>-->
              <!--</c-footer>-->
              <!--<p class="weui-btn-area">-->
              <!--<a href="javascript:history.back();" class="weui-btn weui-btn_primary">推荐操作</a>-->
              <!--<a href="javascript:history.back();" class="weui-btn weui-btn_default">辅助操作</a>-->
              <!--</p>-->
            </div>
          </div>
        </div>
      </c-content>
    </c-page>
    <transition name="slide-right"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
@import './index';
</style>
<script>
import api from '../../tools/api-tools'
import { apiUrl } from '../../config/net'
import device from '../../tools/device'

export default {
  data () {
    return {
      orderPrice: null,
      orderId: null,
      version: ''
    }
  },
  components: {},
  created () {
  },
  async mounted () {
    await this.loadPayStatus()
    this.version = await this.getReleaseVersion()
    this.goToRepay(this.orderId) // 非ios内购跳转
  },
  beforeDestroy () {
  },
  methods: {
    loadPayStatus () {
      let orderNo = this.payStatus.orderNo
      if (this.payStatus.price !== '') return
      if (orderNo === '') return
      return api.get(`${apiUrl}/v0/onlinemall/orderamountv1/${orderNo}`).then(res => {
        let data = res.data.data || {}
        this.orderPrice = data.amount
        this.$store.commit('setOrderId', data.oid)
        this.orderId = data.oid
      }).catch(e => {
        console.log(e)
      })
    },
    // 跳转到失败页
    goToRepay (orderId = null) {
      console.log('执行跳转失败页')
      // 判断是否已经是失败页
      let hashFailed = location.hash.match('failed') ? this.$route.path : `${this.$route.path}/failed`
      if (this.payStatus.status !== 'success') { // 跳转到失败页面
        this.$router.push({ path: hashFailed, query: { orderId: orderId } })
      }
    },
    rePay () {
      this.$router.back()
    },
    goToMarket () {
      this.$router.replace({ path: '/' })
    },
    goToOrderList () {
      this.$router.replace({ path: '/aboutMe/orderDetail' })
    },
    getReleaseVersion () {
      return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/ios/version/beforeRelease`).then(res => {
        return res.data.version || ''
      })
    }
  },
  computed: {
    isPaySuccess () {
      return this.payStatus.status === 'success'
    },
    payStatus () {
      return this.$store.getters.getPayStatus
    },
    price () {
      let price = this.orderPrice ? this.orderPrice : this.payStatus.price
      return price
    },
    goodsId () {
      return this.$store.getters.goodsId
    },
    // 检测是否是在IOS审核的时
    isIOSExamination () {
      return device.ios && (window.localStorage && (window.localStorage.getItem('version').toString() >= this.version.toString()))
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?351d5825